import { usePublish } from '@atlaskit/rovo-triggers';
import type ApolloClient from 'apollo-client';
import { getRovoProductFromExtensionType } from '../utils/getRovoProductFromExtensionType';
import {
	getRovoAgentId,
	DEFAULT_AGENT_REFERENCE,
} from '../../../web-client/queries/getRovoAgentId';
import type { OpenRovoPayload } from '..';

const ROVO_TOPIC = 'ai-mate';
const FORGE_SOURCE = 'forge-bridge-open-rovo';
const ROVO_EVENT_TYPE = 'chat-new';

export function useRovoAgentsChat(
	extensionType: string,
	appId: string,
	cloudId: string | undefined,
	apolloClient: ApolloClient<object>,
) {
	const publish = usePublish(ROVO_TOPIC);

	return {
		openRovo: async ({
			agentKey,
			agentName,
			prompt,
		}: OpenRovoPayload): Promise<false | undefined> => {
			const product = getRovoProductFromExtensionType(extensionType);

			if (!cloudId || !product) {
				return false;
			}

			// If agent name is not provided use default rovo chat agent
			const agentId = agentName
				? await getRovoAgentId({
						client: apolloClient,
						agentAppId: appId,
						cloudId,
						input: { name: agentName },
						product,
						agentKey,
					})
				: DEFAULT_AGENT_REFERENCE;

			publish({
				type: ROVO_EVENT_TYPE,
				product,
				data: {
					dialogues: [],
					agentId,
					...(prompt ? { prompt } : {}),
				},
				source: FORGE_SOURCE,
			});
		},
	};
}
